// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   data: [
//     {
//       id: 1,
//       fullName: "Jay Saini",
//       email: "jaysaini@gmail.com",
//       mobile: "+91 635852548",
//       businessName: "Business 1",
//       productCategory: "Category 1",
//       password: "********",
//       address: "Address 1",
//       averageSellingPrice: "99.000",
//       totalSales: "09",
//       totalCategories: "14",
//       totalRatings: "⭐ 3.4",
//       isActive: true,
//     },
//     {
//       id: 2,
//       fullName: "Vinit Patel",
//       email: "vinitpatel@gmail.com",
//       mobile: "+91 635852548",
//       businessName: "Vinit's Electronics",
//       productCategory: "Electronics",
//       password: "********",
//       address: "76, Ramvila, Ram Temple Road, City, Pincode",
//       averageSellingPrice: "99.000",
//       totalSales: "09",
//       totalCategories: "14",
//       totalRatings: "⭐ 4.4",
//     },
//     {
//       id: 3,
//       fullName: "Jay Saini",
//       email: "jaysaini@gmail.com",
//       mobile: "+91 635852548",
//       businessName: "Business 1",
//       productCategory: "Category 1",
//       password: "********",
//       address: "Address 1",
//       averageSellingPrice: "99.000",
//       totalSales: "09",
//       totalCategories: "14",
//       totalRatings: "⭐ 4.6",
//     },
//     {
//       id: 4,
//       fullName: "Jay Saini",
//       email: "jaysaini@gmail.com",
//       mobile: "+91 635852548",
//       businessName: "Business 1",
//       productCategory: "Category 1",
//       password: "********",
//       address: "Address 1",
//       averageSellingPrice: "99.000",
//       totalSales: "09",
//       totalCategories: "14",
//       totalRatings: "⭐ 3.4",
//     },
//   ],
// };

// const vendorsSlice = createSlice({
//   name: "vendors",
//   initialState,
//   reducers: {},
// });

// export default vendorsSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { vendors } from "../services/api";

// Thunk to fetch vendors data
export const fetchVendors = createAsyncThunk(
  "vendors/fetchVendors",
  async () => {
    const response = await vendors();
    return response;
  }
);

const vendorsSlice = createSlice({
  name: "vendors",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default vendorsSlice.reducer;

